import { Link, useStaticQuery, graphql } from 'gatsby';
import React, { useState } from 'react';
import styled from 'styled-components';
import { CtaButton } from '../styled';

const Box = styled.div`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  margin-left: auto;
  margin-right: auto;
`;

const HamburgerToggleContainer = styled.div`
  background: transparent;
  width: 30px;
`;

const HamburgerLine = styled.div`
  background: black;
  height: 2px;
  border-radius: 1px;

  &:first-child {
    margin-bottom: 10px;
  }
`;

function HamburgerToggle({ open }) {
  return (
    <HamburgerToggleContainer>
      <HamburgerLine />
      <HamburgerLine />
    </HamburgerToggleContainer>
  );
}

const HeaderContainer = styled.div`
  box-sizing: border-box;
  width: 90%;
  max-width: 1128px;
  margin: 0 auto;
  background-color: #FCFCFC;
  position: sticky;
  z-index: 10000;
  top: 0px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  line-height: 56.5px;

  @media (min-width: 992px) {
    justify-content: center;
  }
`;

const HeaderInner = styled.div`
  width: 90%;
  max-width: 1128px;
  margin: 0 auto;
`;

const HeaderMobileToggler = styled.div`
  display: block;
  margin-right: 30px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 992px) {
    display: none;
  }
`;

const HeaderInfo = styled.div`
`;

const HeaderLogo = styled.div`
  box-sizing: border-box;

  img {
    width: 110px;
    margin: 0;
    margin-top: 17px;
  }
`;

const HeaderDivider = styled.div`
  display: inline-block;
  background: #D0D6E6;
  width: 1px;
  height: 30px;
  margin: 0 16px;
`;

const DropdownContainer = styled.div`
  display: none;
  ${({ open }) => open && ` display: block; `}
  text-transform: initial;

  @media (min-width: 992px) {

    position: absolute;
    top: 52px;
    z-index: 10000;
    left: -117px;
    width: 330px;

    /* triangle pointer thing */
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-bottom-color: white;
      border-top: 0;
      margin-left: -8px;
      margin-top: -8px;
    }
  }
`;

// Separate wrapper so we can do rounded-border + overflow, but still show the triangle pointer
const DropdownItemsContainer = styled.div`
  @media (min-width: 992px) {
    background: white;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
  }
`;

const DropdownItem = styled.div`
  &:first-child {
  }

  &:last-child {
    border-bottom: none;
  }

  & a {
    box-sizing: border-box;
    height: 66px;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.36px;

    width: 100%;
    height: 100;
    color: white;
    text-decoration: none;

    @media (min-width: 992px) {
      color: black;

      ${({ emphasis }) => emphasis && `
        background: #f7f7f7;

        &:hover {
          background: #d1d1d1;
        }
      `}
    }
  }

  &:hover {
    background: #f7f7f7;
    cursor: pointer;
  }
`;

const NavContainer = styled.div`
  display: none;
  ${({ open }) => open && `display: block;`}
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1.4px;

  @media (min-width: 992px) {
    display: flex;
    flex-basis: auto;
    flex-grow: unset;
  }
`;

const NavItem = styled.div`
  position: relative;
  text-transform: uppercase;
  user-select: none;
  color: white;
  padding: 0 0 0 22px;

  &:hover {
    cursor: pointer;
  }

  & > a {
    display: block;
    color: #061439;
    text-decoration: none;

    &:hover {
      color: #dddddd;
      cursor: pointer;
    }

    &:active {
      color: #aaaaaa;
    }
  }

  @media (min-width: 992px) {
    margin: 0 8px;
    border: none;
    padding: 0;

    &:hover {
      cursor: initial;
    }

    & ${Link}:hover ${DropdownContainer} {
      display: block;
    }
  }
`;

const IconContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  margin-right: 10px;
  width: 36px;

  img {
    height: 36px;
    ${({ emphasis }) => emphasis && `height: 24px;`}
    margin: 0 auto;
  }
`;

const Label = styled.div`

`;

const SubLabel = styled.div`
  color: #b0b0b0;
  padding-left: 12px;
  font-weight: 300;
`;

function BlogHeader({ siteTitle, ctaLabel }) {
  const headerRes = useStaticQuery(graphql`
    query BlogHeaderQuery {
      prismicBlogHeader {
        data {
          logo {
            url
          }
        }
      }
    }
  `);

  const headerData = headerRes.prismicBlogHeader.data;

  // const navItems = headerData.body;

  const navItems = [
    {
      primary: {
        label: { text: 'Blog'},
        link: { url: '/blog' },
      },
      items: [],
    },
    {
      primary: {
        label: { text: 'Personal Finance'},
        link: { url: '/blog/personal-finance' },
      },
      items: [],
    },
    {
      primary: {
        label: { text: 'Category'},
        link: { url: 'blog/engineering' },
      },
      items: [],
    },
    {
      primary: {
        label: { text: 'Cryptocurrency'},
        link: { url: '/blog/cryptocurrency' },
      },
      items: [],
    },
    {
      primary: {
        label: { text: 'Culture'},
        link: { url: '/blog/culture' },
      },
      items: [],
    },
  ];

  const [navOpen, setNavOpen] = useState(false);
  const [dropdownOpenMap, setDropdownOpenMap] = useState({});

  const handleNavItemClick = (navItem, itemIndex) => {
    if (typeof window !== 'undefined' && window.innerWidth >= 992) { return; }
    if (!navItem.items.length) { return; }

    const newDropdownOpenMap = { [itemIndex]: !dropdownOpenMap[itemIndex] };
    setDropdownOpenMap(newDropdownOpenMap);
  };

  return (
    <HeaderContainer>
        <HeaderInfo>
          <HeaderLogo>
            <a href="/"><img src={headerData.logo.url} /></a>
            <HeaderDivider/>
            <span>Blog</span>
          </HeaderLogo>
        </HeaderInfo>
        <HeaderMobileToggler onClick={() => setNavOpen(!navOpen)}>
          <HamburgerToggle />
        </HeaderMobileToggler>
        <Box/>
        <NavContainer open={navOpen}>
          {navItems.map((navItem, index) => {
            return (
              <NavItem
                key={index}
                onClick={(e) => handleNavItemClick(navItem, index)}
              >
                <Link
                  to={navItem.primary.link ? navItem.primary.link.url : '/'}
                >
                  {navItem.primary.label.text}
                </Link>
                {navItem.items.length > 0 &&
                  <DropdownContainer open={dropdownOpenMap[index]}>
                    <DropdownItemsContainer>
                      {navItem.items.map((subItem, index) => {
                        return (
                          <DropdownItem key={index} emphasis={index === (navItem.items.length - 1) || index === (navItem.items.length - 2)}>
                            <Link to={subItem.dropdown_item_link ? subItem.dropdown_item_link.url : '#'}>
                              <IconContainer emphasis={index === (navItem.items.length - 2)}>
                                <img src={subItem.icon.url} />
                              </IconContainer>
                              <Label>
                                {subItem.dropdown_item_label.text}
                              </Label>
                              <SubLabel>
                                {subItem.dropdown_item_sublabel.text}
                              </SubLabel>
                            </Link>
                          </DropdownItem>
                        );
                      })}
                    </DropdownItemsContainer>
                  </DropdownContainer>
                }
              </NavItem>
            );
          })}
        </NavContainer>
    </HeaderContainer>
  );
}

export { BlogHeader };
